/**
 * Babel includes a polyfill that includes a custom regenerator runtime and core-js.
 * This will emulate a full ES2015+ environment and is intended to be used in an
 * application rather than a library/tool.
 */

require('babel-polyfill');

/**
 * Here we load the lodash modules that are necessary to make some stuff inside our
 * application work. Note that we're not including the whole lodash library, since
 * this would be a huge number of bytes added to the bundle.
 */

window._chunk = require('lodash.chunk'); // eslint-disable-line
window._values = require('lodash.values'); // eslint-disable-line
window._debounce = require('lodash.debounce'); // eslint-disable-line

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Modernizr tests touchevents.
 */

require('browsernizr/test/touchevents');
require('browsernizr/lib/addTest');
window.Modernizr = require('browsernizr');

Modernizr.addTest('iphone', () => {
    return !!navigator.userAgent.match(/iPhone/i);
});

/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */

window.Vue = require('vue');

/**
 * EventBus used to communicate between the webapplication components.
 * */

window.EventBus = new Vue();

/**
 * Zenscroll is a vanilla JavaScript library that enables animated
 * vertical scrolling to an element or position within your
 * document or within a scrollable element (DIV, etc.).
 */

window.zenscroll = require('zenscroll');

/**
 * Give our fellow console loggers some love!
 */

console.log('%c Made with 🖤 by 51North: https://51north.nl ', 'background: #fff; color: #000'); // eslint-disable-line

/**
 * Register potential service worker.
 */

/* eslint-disable no-unused-expressions */
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.getRegistrations().then((registrations) => {
            if (!registrations.length) {
                console.log('No serviceWorker registrations found.');
                return;
            }
            for (const registration of registrations) {
                registration.unregister().then((boolean) => {
                    console.log((boolean ? 'Successfully unregistered' : 'Failed to unregister'), 'ServiceWorkerRegistration\n' +
                        (registration.installing ? '  .installing.scriptURL = ' + registration.installing.scriptURL + '\n' : '') +
                        (registration.waiting ? '  .waiting.scriptURL = ' + registration.waiting.scriptURL + '\n' : '') +
                        (registration.active ? '  .active.scriptURL = ' + registration.active.scriptURL + '\n' : '') +
                        '  .scope: ' + registration.scope + '\n');
                });
            }
        });

        // navigator.serviceWorker.register('/sw-dont-register.js', {
        //     scope: '/',
        // }).then((registration) => {
        //     // Registration was successful, trim the caches on load
        //     navigator.serviceWorker.controller && navigator.serviceWorker.controller.postMessage({
        //         command: 'trimCaches',
        //     });
        // }).catch((err) => {
        //     // Registration failed, fail silently
        //     // console.log('ServiceWorker registration failed: ', err);
        // });
    });
}
/* eslint-enable no-unused-expressions */



// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap.js